<template>
	<a href="https://chirana.pl" :class="`${classPrefix}__back-link`">
		<BackArrow />
		<span :class="`uppercased-text ${classPrefix}__back-text`">Powrót do strony</span>
	</a>
</template>

<script>
import BackArrow from './BackArrow';

export default {
	name: 'BackLink',
	components: {BackArrow},
	props: {
		classPrefix: {
			type: String,
			required: true,
		},
	},
};
</script>
